import React from 'react';
import { useForm } from 'react-hook-form';
import { Icon } from '../../../resources';
import { RowSearchLayout } from '../../../components/page-layout/views/RowSearchLayout';
import { STOCK_ROW_STATE, STOCK_STATE_LABEL } from '../claim-product/resource/stockConst';
import { APPROVAL_STOCK_ALL } from './approvalStock';
import { ClaimCountLegend } from './claimCountIcon';

const DEFAULT_VALUES = { search: '', stockStatus: APPROVAL_STOCK_ALL };

export const ApprovalFilters = ({ onSearch }) => {
  const form = useForm({ defaultValues: DEFAULT_VALUES });
  const submit = ({ search, stockStatus, reset = false }) =>
    onSearch({
      search: search?.trim() ?? '',
      stockStatus: stockStatus ?? APPROVAL_STOCK_ALL,
      reset,
    });
  const formSearch = [
    {
      name: 'search',
      label: 'ค้นหารายการ (ชื่อ, เลขเคลม, เบอร์โทร)',
      type: 'INPUT',
      span: 15,
      onEnter: () => form.handleSubmit(submit)(),
    },
    {
      name: 'stockStatus',
      label: 'สถานะสต็อก',
      type: 'DROPDOWN',
      placeholder: 'เลือกสถานะสต็อก',
      span: 9,
      properties: {
        options: [
          { value: APPROVAL_STOCK_ALL, label: 'ทั้งหมด' },
          ...[
            STOCK_ROW_STATE.OK,
            STOCK_ROW_STATE.OUT_OF_STOCK,
            STOCK_ROW_STATE.OVER_SELECTED,
            STOCK_ROW_STATE.UNKNOWN,
            STOCK_ROW_STATE.STALE,
          ].map((value) => ({ value, label: STOCK_STATE_LABEL[value] })),
        ],
      },
    },
  ];

  return (
    <RowSearchLayout
      props={{
        title: 'ค้นหาคำขออนุมัติ',
        icon: <Icon.todo />,
        formSearch,
        useFormParam: form,
        onSearch: submit,
        onClearCustom: () => {
          form.reset(DEFAULT_VALUES);
          submit({ ...DEFAULT_VALUES, reset: true });
        },
      }}
    >
      <div style={{ width: '100%', marginTop: '8px' }}>
        <ClaimCountLegend framed={false} />
      </div>
    </RowSearchLayout>
  );
};
